export default __webpack_public_path__ + "static/iphone-256c4513f8702f226c99a23e7a983da8.png";